// **React Imports
import React, { Suspense, useContext, useMemo } from 'react'
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom'

// **MUI Imports
import { styled } from '@mui/material'

// **Component Imports
import Header from '../components/header'
import OverlayLoading from '../components/overlay-loading'
import ErrorBoundary from '../pages/error'

// **Context Imports
import { SettingsContext } from '../context/setting'

// **Utils Imports
import CandidateDetailsModal from '../components/candidate-detail-modal'
import { checkCandidateAccess, removeJWTToken } from '../utils/utils'
import Breadcrumbs from '../components/breadcrumbs'

// **Styled Component
const MainContainer = styled('main')(({ theme, contentWidth }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',

  ...(contentWidth === 'boxed'
    ? {
        margin: '0 auto',
        maxWidth: '1440px'
      }
    : {}),
  [theme.breakpoints.up('md')]: {
    padding: '24px 16px'
  },
  [theme.breakpoints.down('md')]: {
    padding: '16px 8px'
  }
}))

const CandidatePrivateRoute = () => {
  // hooks
  const { contestUri } = useParams()
  const {
    settings: { contentWidth, appBarHidden, removePadding }
  } = useContext(SettingsContext)
  const location = useLocation()

  // variable
  const globalCandidatePath = useMemo(() => {
    const path = location.pathname?.trim()?.toLowerCase()
    return path.endsWith('/c') || path.endsWith('/c/') || path.includes('/c/')
  }, [location.pathname])

  if (checkCandidateAccess()) {
    return (
      <React.Fragment>
        {!appBarHidden && <Header candidatePathHeader={true} />}
        <Breadcrumbs />
        <ErrorBoundary>
          <Suspense fallback={<OverlayLoading />}>
            <MainContainer
              contentWidth={contentWidth}
              sx={{ ...(removePadding ? { padding: '0 !important' } : {}) }}
            >
              <Outlet />
            </MainContainer>
          </Suspense>
        </ErrorBoundary>
        <CandidateDetailsModal />
      </React.Fragment>
    )
  } else {
    removeJWTToken()

    return contestUri ? (
      <Navigate to={`/c/${contestUri}/login`} replace />
    ) : globalCandidatePath ? (
      <Navigate to={'/candidates/login'} replace />
    ) : (
      <Navigate to={'/login'} replace />
    )
  }
}

export default CandidatePrivateRoute
